package anjuros.development.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import anjuros.development.components.language.LocalText
import anjuros.development.modules.Section
import anjuros.development.modules.Theme
import anjuros.development.util.Constants
import anjuros.development.util.MenuWidthStyle
import anjuros.development.util.NavigationItemStyle
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.argb
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.scrollBehavior
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateX
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaXmark
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun OverflowMenu(onMenuClosed:()->Unit){

    val breakPoint = rememberBreakpoint()
    val scope = rememberCoroutineScope()
    var translateX by remember { mutableStateOf((-100).percent) }
    var opacity by remember { mutableStateOf(0.percent) }


    LaunchedEffect(breakPoint){
        translateX=0.percent
        opacity=100.percent
        if(breakPoint > Breakpoint.MD) {
            scope.launch {
                translateX=(-100).percent
                opacity=0.percent
                delay(500)
                onMenuClosed()
            }
        }
    }

    Column(modifier = Modifier
        .fillMaxWidth()
        .height(100.vh)
        .position(Position.Fixed)
        .zIndex(2)
        .opacity(opacity)
        .backgroundColor(argb(a=0.5f,r=0.0f,g=0.0f,b=0.0f))
        .transition(Transition.of(property = "opacity", duration = 500.ms))) {

        Column(modifier = MenuWidthStyle.toModifier()
            .padding(25.px)
            .overflow(Overflow.Auto)
            .borderRadius(bottomRight = 20.px)
            .scrollBehavior(ScrollBehavior.Smooth)
            .backgroundColor(Theme.OpacityPrimary2.rgb)
            .translateX(tx=translateX)
            .transition(Transition.of(property = "translate", duration = 500.ms))){

            Row(
                modifier = Modifier
                    .margin(bottom = 25.px),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Start
            ){
                FaXmark(
                    modifier = Modifier
                        .cursor(Cursor.Pointer)
                        .color(Colors.White)
                        .margin(right = 10.px, bottom = 3.px)
                        .onClick {
                            scope.launch {
                                translateX=(-100).percent
                                opacity=0.percent
                                delay(500)
                                onMenuClosed()
                            }
                        },
                    size = IconSize.LG

                )


            }

            Section.entries.toTypedArray().forEach { section->
                Link(
                    modifier = Modifier
                        .textDecorationLine(TextDecorationLine.None),
                    path = section.path,
                    openInternalLinksStrategy = OpenLinkStrategy.IN_PLACE
                ){
                    P(
                        attrs = NavigationItemStyle.toModifier()
                            .margin(bottom = 10.px)
                            .fontFamily(Constants.FONT_FAMILY)
                            .fontSize(16.px)
                            .fontWeight(FontWeight.Normal)
                            .color(Colors.White)
                            .onClick {
                                scope.launch {
                                    translateX=(-100).percent
                                    opacity=0.percent
                                    delay(500)
                                    onMenuClosed()
                                }
                            }
                            .toAttrs()
                    ) {
                        Text(LocalText(section.subtitle))
                    }
                }

            }
        }

    }
}